import { RadioList } from "./RadioList";
import { Item } from "./Item";

RadioList.Item = Item;

export { RadioList, Item };
